
































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import SimpleDropdown from './SimpleDropdown.vue';


@Component({
  components: {
    SimpleDropdown,
  },
})
export default class DetailCard extends Vue {
  @Prop() private editMode!: boolean;
  @Prop() private type!: string;
  @Prop() private title!: string;
  @Prop() private desc!: string;
  @Prop() private foot!: string;
  @Prop() private footDropdown!: Object;
  @Prop() private headDropdown!: Object;
  onClick(...args: any[]) {
    this.$emit('item-click', ...args);
  }
}
